import { RootState } from 'rootReducer';

export const getIsUserConnected = (state: RootState) => state.wsConnection.isUserConnected;
export const getIsUserOpened = (state: RootState) => state.wsConnection.isUserOpened;
export const getIsCodeOpened = (state: RootState) => state.wsConnection.isCodeOpened;
